import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import GameService from '../../services/game.service';

export const enterTournament = createAsyncThunk(
  'tournamentEntry/enterTournament',
  async ({ gameName, lobbyId }, { rejectWithValue }) => {
    try {
      const entryResponse = await GameService.getGamePlayDetails({ gameName, lobbyId });

      return entryResponse;
    } catch (error) {
      // `code` is the operator decline (e.g. INSUFFICIENT_FUNDS) — the lobby
      // branches on it; `message` is the server's player-facing copy.
      return rejectWithValue({
        message: error.response?.data?.message || 'Failed to enter tournament',
        code: error.response?.data?.code ?? null,
      });
    }
  }
);

const initialState = {
  status: 'idle',
  error: null,
  data: null,
};

const gamePlaySlice = createSlice({
  name: 'gamePlay',
  initialState,
  reducers: {
    resetGamePlay: (state) => {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(enterTournament.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(enterTournament.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload.data;
      })
      .addCase(enterTournament.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload?.message || 'Something went wrong';
      });
  },
});

export const { resetGamePlay } = gamePlaySlice.actions;
export default gamePlaySlice.reducer;
